<template>
  <div class="lauatd">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:right>
        <el-button
          @click="onHandleExport"
          type="warning"
          icon="el-icon-upload2"
          :disabled="disabledExport"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="supply_time" align="center" label="供货日期">
        </el-table-column>
        <el-table-column prop="op_type_text" align="center" label="收支类型">
        </el-table-column>
        <el-table-column prop="flow_type_text" align="center" label="类型">
        </el-table-column>
        <el-table-column prop="flow_no" align="center" label="流水号">
        </el-table-column>
        <el-table-column prop="amount" align="center" label="动帐金额">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="wallet_amount"
          align="center"
          label="账户余额"
        >
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="动帐时间">
        </el-table-column>
        <el-table-column
          prop="desc"
          align="center"
          label="描述"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import { cloneDeep } from "lodash";
export default {
  name: "lauud",
  components: {
    Filtersearch,
  },
  data() {
    return {
      currentPage: 0,
      total: 0,
      loading: false,
      disabledExport: false, // 导出按钮
      tableData: [],
      centerDialogVisible: false,
      Filterdata: "",
      Filterdata1: "",
      Filterdata2: "",
      itemobj: "",

      from: {
        page: 1, //	T文本	是
        pageSize: 50, //	T文本	是
        logistic_business_id: "", //	T文本	是	集配中心id
        time: "",
        flow_type: "", //	T文本	是

        op_type: "", //	T文本	是	收支类型10-收入 20-支出
        flow_no: "", //	T文本	是
        flow_source: "", //	T文本	是
        supply_time_start: "", //	T文本	是
        supply_time_end: "", //	T文本	是	结束时间
      },
      from1: "",
      Selectionlist: [],
      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选集配中心",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "business_list",
        },

        {
          type: "daterange",
          name: "动账日期",
          clearable: true,
          model: "time",
          startmodel: "supply_time_start",
          endmodel: "supply_time_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
        },
        {
          type: "select",
          name: "收支类型",
          clearable: true,
          model: "op_type",
          selectoptionname: "op_type",
          placeholder: "请选收支类型",
          label: "value",
          value: "index",
          selectoption: [],
        },
        {
          type: "select",
          name: "类型",
          clearable: true,
          filterable: true,
          model: "flow_type",
          placeholder: "请选类型",
          label: "value",
          value: "index",
          selectoptionname: "flow_type_list",
          selectoption: [],
        },
        {
          type: "input",
          name: "流水号",
          clearable: true,
          model: "flow_no",
          placeholder: "请输入流水号",
        },
        {
          type: "select",
          name: "来源",
          clearable: true,
          filterable: true,
          model: "flow_source",
          placeholder: "请选来源",
          label: "value",
          value: "index",
          selectoptionname: "flow_source",
          selectoption: [],
        },
      ],
    };
  },
  created() {
    if (this.$route.query.fleet_id) {
      this.from.fleet_id = Number(this.$route.query.fleet_id);
    }
    this.from.time = this.getThisWeek();
    this.from.supply_time_start = this.getThisWeek()[0];
    this.from.supply_time_end = this.getThisWeek()[1];
    this.from1 = JSON.parse(JSON.stringify(this.from));
    console.log(this.getThisWeek());

    // this.hqlist();
    this.getsearch();
    this.getflowtype();
    // this.getfleetlist();
  },
  watch: {},
  methods: {
    getThisWeek() {
      const today = new Date();
      const dayOfWeek = today.getDay(); // 0为周日，1为周一

      // 计算本周一的日期 (如果是周日，则为上周一)
      const monday = new Date(today);
      const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      monday.setDate(today.getDate() - daysToSubtract);

      // 计算本周日的日期
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);

      // 格式化为 yyyy-MM-dd
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      return [formatDate(monday), formatDate(sunday)];
    },
    /**
     * 导出逻辑
     */
    async onHandleExport() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.from,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;
        delete query.time;

        let form = cloneDeep(query);
        form.supply_time_start =
          new Date(query.supply_time_start).getTime() / 1000 || "";
        form.supply_time_end =
          new Date(query.supply_time_end).getTime() / 1000 || "";
        this.$api.general.bicontractrelistexport(form).then((res) => {
          this.goExportCenter();
        });
      } catch (err) {
        this.$message.error("导出失败了");
        console.log("ajax getAfterSaleNewUnExport err", err);
        console.log("ajax postPurchaseSettleExport err", err);
      } finally {
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    getfleetlist() {
      this.$api.fz
        .fleetlist({
          type: 1,
        })
        .then((res) => {
          this.Filterdata2 = res.data;
          this.Filtersearchlist.forEach((el) => {
            if (el.selectoptionname == "fleet_id_list") {
              // let obj = { [el.value]: "", [el.label]: "全部" };
              el.selectoption = res.data;
            }
          });
        });
    },
    getflowtype() {
      this.$api.general.dashinit().then((res) => {
        this.Filterdata1 = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (el.selectoptionname == "op_type") {
            // let obj = { [el.value]: "", [el.label]: "全部" };
            el.selectoption = res.data.op_type;
          }
          if (el.selectoptionname == "flow_type_list") {
            // let obj = { [el.value]: "", [el.label]: "全部" };
            el.selectoption = res.data.flow_type;
          }
          if (el.selectoptionname == "flow_source") {
            // let obj = { [el.value]: "", [el.label]: "全部" };
            el.selectoption = res.data.flow_source;
          }
        });
      });
    },
    getsearch() {
      this.$api.ban.searchdata().then((res) => {
        console.log(res, "qqqqewq");
        this.Filterdata = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (el.selectoptionname == "business_list") {
            el.selectoption = res.data[el.selectoptionname];
            this.from.logistic_business_id = res.data.business_list[0].id;
            this.from1.logistic_business_id = res.data.business_list[0].id;
            this.hqlist();
          }
        });
      });
    },
    Refresh() {
      // this.Filtersearchlist.forEach((el) => {
      //   if (el.selectoptionname == "business_list") {
      //     el.selectoption = this.Filterdata[el.selectoptionname];
      //   }
      // });
      // this.Filtersearchlist.forEach((el) => {
      //   if (el.selectoptionname == "flow_type_list") {
      //     el.selectoption = this.Filterdata1;
      //   }
      // });
      // this.Filtersearchlist.forEach((el) => {
      //   if (el.selectoptionname == "fleet_id_list") {
      //     el.selectoption = this.Filterdata2;
      //   }
      // });
      Object.assign(this.$data.from, this.$options.data().from);

      this.from.supply_time_start = this.getThisWeek()[0];
      this.from.supply_time_end = this.getThisWeek()[1];
      this.$api.ban.searchdata().then((res) => {
        console.log(res, "qqqqewq");
        this.Filterdata = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (el.selectoptionname == "business_list") {
            el.selectoption = res.data[el.selectoptionname];
            this.from.logistic_business_id = res.data.business_list[0].id;
            this.from1 = JSON.parse(JSON.stringify(this.from));
            this.hqlist();
          }
        });
      });
    },

    search(e) {
      this.from = e;
      this.from1 = e;
      this.from.page = 1;
      this.currentPage = 1;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      let form = cloneDeep(this.from);
      form.supply_time_start =
        new Date(form.supply_time_start).getTime() / 1000;
      form.supply_time_end = new Date(form.supply_time_end).getTime() / 1000;
      this.$api.general.walletdetaillist(form).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.hqlist();
    },
  },
};
</script>
<style lang="scss">
.lauatd {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  .contents {
    padding: 0 20px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
